import type { QuickNavigatorProps } from '@vista-digital/occ-ui'
import { FilmThumbnailMediaType } from '@vista-digital/occ-ui'
import type { NestedPartial } from '@vista-digital/utilities'

export const quickBookConfig: Omit<NestedPartial<QuickNavigatorProps>, 'ref'> = {
    config: {
        sites: {
            enableSearch: false,
            showModalOnMobile: false,
        },
        films: {
            enableSearch: false,
            showModalOnMobile: false,
            mediaType: FilmThumbnailMediaType.Still,
        },
        showtimes: {
            showModalOnMobile: false,
            enableSearch: false,
        },
        screeningDates: {
            showModalOnMobile: false,
        },
        dropdownLabel: { show: false },
        headingLabel: { show: false },
    },
}
